import { Component, OnInit } from '@angular/core';
import { PublicityService } from 'src/app/services/publicity.service';
import { Observable, of } from 'rxjs';
import { Publicity } from 'src/app/models/publicity';
import { async } from '@angular/core/testing';
import { AnalitycsService } from 'src/app/services/analitycs.service';

@Component({
  selector: 'app-publicidad',
  templateUrl: './publicidad.component.html',
  styleUrls: ['./publicidad.component.scss'],
})
export class PublicidadComponent implements OnInit {
  filacarrusel: any;
  flechaIzquierda: any;
  flechaDerecha: any;
  contador = 0;
  intervalo: any;
  publicity: Promise<Publicity[]>;
  publicidad = [];
  constructor(private publicityServ: PublicityService, private analytics: AnalitycsService) {}

  async ngOnInit() {
    this.publicity = this.publicityServ.getVisible();
  }
  ngAfterContentInit() {
    this.getElementBackGroundScreen(document);
    this.getImagePublicity();
  }
  ngOnDestroy() {
    clearInterval(this.intervalo);
  }

  analyticsEvnt(){
    this.analytics.logEvents("Publicidad");
  }

  getImagePublicity() {
    this.publicity.then((publicity) => {
      for (let index = 0; index < publicity.length; index++) {
        const element = publicity[index];
        this.publicidad.push(element.image);
      }
    });
  }

  getElementBackGroundScreen(d: any) {
    /*CARRUCEL*/
    let max, pantalla;
    this.intervalo = setInterval(() => {
      this.filacarrusel = d.querySelector('.control-carrusel-publicidad');
      max = this.filacarrusel.offsetWidth;
      pantalla = screen.width;
      if (pantalla <= 800 && pantalla > 500) {
        max = max / 2;
        this.filacarrusel.scrollLeft += max;
        if (this.contador > this.filacarrusel.scrollLeft) {
          this.filacarrusel.scrollLeft = 0;
          this.contador = 0;
        }
        this.contador = Math.trunc(this.contador + max);
      } else if (pantalla <= 500) {
        max = max / 1;
        this.filacarrusel.scrollLeft += max;
        if (this.contador > this.filacarrusel.scrollLeft) {
          this.filacarrusel.scrollLeft = 0;
          this.contador = 0;
        }
        this.contador = Math.trunc(this.contador + max);
      } else if (pantalla > 800) {
        max = max;
        this.filacarrusel.scrollLeft += max;
        if (this.contador > this.filacarrusel.scrollLeft) {
          this.filacarrusel.scrollLeft = 0;
          max = 0;
          this.contador = 0;
        }
        this.contador = Math.trunc(this.contador + max);
      }
    }, 5000);
  }
}
